import { render, staticRenderFns } from "./Prerequisites.vue?vue&type=template&id=10245d78&"
import script from "./Prerequisites.vue?vue&type=script&lang=ts&"
export * from "./Prerequisites.vue?vue&type=script&lang=ts&"
import style0 from "./Prerequisites.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports